import { Box, Grid, styled } from '@mui/material'

export const PanelContainer = styled(Grid)({
  flex: 1,
  display: 'flex',
})
export const PanelSide = styled(Grid)({
  flex: 1,
})
export const PanelSidePadding = styled(Box)({})
